import {infiniteQueryOptions, keepPreviousData} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import {keys} from './keys';

export type ListWorkoutTemplatesQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const listWorkoutTemplatesQuery = (
  {controllers}: ListWorkoutTemplatesQueryDependencies,
  q = '',
) =>
  infiniteQueryOptions({
    queryKey: [...keys.templates.list(), q] as const,
    queryFn: ({pageParam}) =>
      controllers.workoutController.listTemplates({cursor: pageParam, q}).then(unwrap),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
  });
